<template>
  <div id="home" v-bind:class="{ compact: isCompact }">
    <Navbar :is-compact="isCompact" />
    <div class="container-fluid">
      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { EventBus } from '@/lib/event-bus';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Main',
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      isCompact: false,
    };
  },
  created() {
    EventBus.$on('isCompact', (isCompact) => {
      this.setIsCompact(isCompact);
    });
  },
  methods: {
    setIsCompact(isCompact) {
      this.isCompact = isCompact;
    },
  },
};
</script>
<style lang="scss">
  @import "../assets/main.scss";
</style>
